import Button from "components/Button";
import Content from "components/Content";
import Label from "components/Label";
import Image from "next/image";
import React, { FC } from "react";
import { HiOutlineCheck as CheckIcon } from "react-icons/hi";

import Shape1 from "../../../../../public/shape-5.svg";
import Shape2 from "../../../../../public/shape-10.svg";

import styles from "./styles.module.scss";

interface Props {
  heading: {
    title: string;
    the_plan: {
      title: string;
      includes: string[];
    };
    image: string;
    cta: { reads: string; file: string };
  };
  what_you_get: {
    title: string;
    services: { title: string; description: string; includes: string[] }[];
  };
}

const MaintenancePlan: FC<Props> = ({ heading, what_you_get: whatYouGet }) => {
  return (
    <Content
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <Shape1 className={styles.shape1} />
      <Shape2 className={styles.shape2} />
      <Label color="white" variant="h-centered" className={styles.title}>
        {heading.title}
      </Label>
      <div className={styles.top}>
        <div className={styles.leftPanel}>
          <Label variant="h" className={styles.headingTitle} color="white">
            {heading.the_plan.title}
          </Label>
          <div className={styles.includes}>
            {heading.the_plan.includes.map((item) => (
              <div className={styles.included}>
                <CheckIcon className={styles.check} />
                <Label variant="s" color="white" className={styles.serviceItem}>
                  {item}
                </Label>
              </div>
            ))}
          </div>
          <Button
            variant="cta"
            onClick={() => window.open(heading.cta.file, "_blank")}
          >
            {heading.cta.reads}
          </Button>
        </div>
        <div className={styles.imageWrapper}>
          <Image alt="" layout="fill" objectFit="cover" src={heading.image} />
        </div>
      </div>
    </Content>
  );
};

export default MaintenancePlan;
